export const styles = () => ({
  filterPanelContainer: {
    overflow: 'visible',
    width: '99.5%',
    marginLeft: 10,
    flexDirection: 'initial',
  },
});
